const getCookie = name => {
  const nameExpression = `${name}=`;
  const cookies = document.cookie.split(';');
  const cookie = cookies.find(currentCookie => currentCookie.includes(nameExpression));  
  return cookie ? cookie.trim().substring(nameExpression.length, cookie.length) : null;
}

const setCookie = (name, value, expire = 365, path = '/') => {
  const date = new Date();
  date.setTime(date.getTime() + (expire * 24 * 3600 * 1000));
  const expires = date.toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=${path}`;
};

class SignupPopup extends HTMLElement {
  constructor() {
    super();
    this.cookieName = 'signup-newsletter';
    this.cookie = getCookie(this.cookieName);
    if(this.cookie !== 'show') {
      setTimeout(() => {
        this.open();
      }, 8000);
    }
  }

  close() {
    this.classList.add('hidden');
    setCookie(this.cookieName, "show", 2);
  }

  open() {
    this.classList.remove('hidden');
  }
}

class SignupPopupModal extends HTMLElement {
  constructor() {
    super();
    this.parent = this.closest('signup-popup');
    document.getElementById('Signup-Close').addEventListener('click', (e) => {
      e.preventDefault();
      this.parent.close();
    })
  }
}

class SignupPopupForm extends HTMLElement {
  constructor() {
    super();
    this.parent = this.closest('signup-popup-modal')
  }
}

if (Shopify.designMode) {
  customElements.define('signup-popup', class extends HTMLElement {
    constructor() {
      super();
    }

    open() {
      this.classList.remove('hidden');
    }

    close() {
      this.classList.add('hidden');
    }
  })
}
else {
  customElements.define('signup-popup', SignupPopup)
  customElements.define('signup-popup-modal', SignupPopupModal)
  customElements.define('signup-popup-form', SignupPopupForm)
}